var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "tabs" },
      _vm._l(_vm.tabs, function(tab) {
        return _c(
          "a",
          {
            staticClass: "button mod-tab",
            class: { active: tab.isActive },
            attrs: { href: tab.href, role: "tab", rel: "nofollow" },
            on: {
              click: function($event) {
                return _vm.selectTab(tab)
              }
            }
          },
          [_vm._v(_vm._s(tab.name))]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "tab-content" },
      [
        _vm._t("default"),
        _vm._v(" "),
        _c("div", { staticClass: "loader", class: { loading: _vm.loading } })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }